import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-108667e8")

_pushScopeId("data-v-108667e8")
const _hoisted_1 = { class: "py2 navigation flex flex-column justify-between" }
const _hoisted_2 = { class: "flex flex-column navigation__list" }
const _hoisted_3 = { class: "flex flex-column items-stretch center" }
const _hoisted_4 = { class: "input-wrapper input-wrapper--flex mt2 justify-center language-wrapper" }
const _hoisted_5 = { for: "language" }
const _hoisted_6 = /*#__PURE__*/_createVNode("option", { value: "en" }, "EN", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("option", { value: "pl" }, "PL", -1)
const _hoisted_8 = { class: "my1 h3 navigation__company" }
const _hoisted_9 = { class: "mb2 navigation__email" }
const _hoisted_10 = { class: "support-contact-label mt2 mb1" }
const _hoisted_11 = {
  class: "bold mb2",
  target: "_blank",
  href: "mailto:contact@getremotefun.com"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", null, [
      _createVNode("img", {
        src: require(`@/assets/logos/remote-fun/logo-white-text-white.svg`),
        alt: "logo",
        class: "navigation__logo mb3"
      }, null, 8, ["src"]),
      _createVNode("ul", _hoisted_2, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.navigationItems, (item) => {
          return (_openBlock(), _createBlock(_Fragment, null, [
            (item.type === 'heading')
              ? (_openBlock(), _createBlock("div", {
                  class: "h5 my2 navigation__heading",
                  key: item.label
                }, _toDisplayString(item.label), 1))
              : (_openBlock(), _createBlock(_component_router_link, {
                  key: item.path,
                  to: item.path,
                  style: item.disabled && { pointerEvents: 'none', cursor: 'not-allowed' }
                }, {
                  default: _withId(({ isExactActive }) => [
                    _createVNode("li", {
                      class: ["mx1 flex items-center navigation__item", isExactActive && 'active']
                    }, [
                      (item.icon)
                        ? (_openBlock(), _createBlock("div", {
                            key: 0,
                            class: ["mr1 navigation__item-icon", item.icon]
                          }, null, 2))
                        : _createCommentVNode("", true),
                      (item.image)
                        ? (_openBlock(), _createBlock("img", {
                            key: 1,
                            class: "mr1 navigation__item-image",
                            src: item.image,
                            alt: item.icon
                          }, null, 8, ["src", "alt"]))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(item.label), 1)
                    ], 2)
                  ]),
                  _: 2
                }, 1032, ["to", "style"])),
            (item.submenu && !item.submenuHidden)
              ? (_openBlock(), _createBlock("div", {
                  key: item.path,
                  class: "mb2 submenu"
                }, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.submenu, (submenuItem) => {
                    return (_openBlock(), _createBlock("div", {
                      key: submenuItem.path,
                      onClick: ($event: any) => (_ctx.$router.push(submenuItem.path))
                    }, [
                      _createVNode(_component_router_link, {
                        key: submenuItem.path,
                        to: submenuItem.path
                      }, {
                        default: _withId(({ isExactActive }) => [
                          _createVNode("li", {
                            class: ["mt1", isExactActive && 'active']
                          }, _toDisplayString(submenuItem.label), 3)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ], 8, ["onClick"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ], 64))
        }), 256))
      ])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('adminPanel.navigation.language')), 1),
        _withDirectives(_createVNode("select", {
          id: "language",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$i18n.locale = $event))
        }, [
          _hoisted_6,
          _hoisted_7
        ], 512), [
          [_vModelSelect, _ctx.$i18n.locale]
        ])
      ]),
      _createVNode("div", _hoisted_8, _toDisplayString(_ctx.company.name), 1),
      _createVNode("div", _hoisted_9, _toDisplayString(_ctx.user && _ctx.user.email), 1),
      _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('adminPanel.navigation.support')), 1),
      _createVNode("a", _hoisted_11, _toDisplayString(`contact@getremotefun.com`), 1),
      _createVNode(_component_Button, {
        class: "p-button-white",
        onClick: _ctx.logout
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('adminPanel.navigation.logout')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
})